<template>
  <div class="joinOurCommunity">
    <p class="joinOurCommunity__title">
      {{ $t("We Invite You to Join Our Global Community!") }}
    </p>

    <div class="joinOurCommunity__steps steps">
      <div class="steps__item" v-for="(step, index) in steps" :key="index">
        <p class="steps__title">{{ index + 1 }}</p>
        <p class="steps__text">{{ step }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "JoinOurCommunity",

  computed: {
    steps() {
      return [
        this.$t("Register with Platin World"),
        this.$t("Review the tools and instructions in your personal cabinet"),
        this.$t("Start building your team"),
        this.$t("Earn money with technologies!"),
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.joinOurCommunity {
  padding: 64px 16px;

  background: $color-blue-3 url("~img/landing/earth-bg.png") center center
    no-repeat;

  @media (min-width: $breakpoint-xl) {
    padding: 96px 32px;
  }

  &__title {
    text-align: center;
    font-weight: 700;
    font-family: $font-secondary;
    font-size: 20px;
    line-height: 32px;
    color: #fff;

    @media (min-width: $breakpoint-xl) {
      font-size: 24px;
    }
  }
}

.steps {
  overflow: hidden;

  margin-top: 48px;

  @media (min-width: $breakpoint-md) {
    display: flex;
  }

  @media (min-width: $breakpoint-xl) {
    margin-top: 64px;
  }

  &__item {
    &:not(:first-child) {
      border-top: 1px solid rgba(255, 255, 255, 0.5);
    }

    flex: 1 25%;
    margin-top: -1px;
    text-align: center;

    @media (min-width: $breakpoint-md) {
      &:not(:first-child) {
        border-top: 0;
        border-left: 1px solid rgba(255, 255, 255, 0.5);
      }
      border-top: 0;
      margin-left: -1px;
      padding: 0 32px;
    }

    @media (min-width: $breakpoint-xl) {
      padding: 0 48px;
    }

    & + & {
      margin-top: 24px;
      padding-top: 24px;

      @media (min-width: $breakpoint-md) {
        margin-top: 0;
        padding-top: 0;
      }
    }
  }

  &__title {
    color: #fff;
    font-size: 72px;
    font-family: $font-secondary;
    line-height: 72px;
  }

  &__text {
    @include text-h4;

    color: #fff;
    margin-top: 16px;
  }
}
</style>
